import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { AprovarPedidoService } from '../../../services/aprovarPedido/aprovarPedidoService';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { StateType } from 'domain/types/base/base';
import { CAMPANHA_RESGATE_APROVAR, CAMPANHA_RESGATE_REPROVAR } from '../../../types/aprovarPedido/aprovarPedido';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';

const _AprovarPedidoService = new AprovarPedidoService();

export function AprovarResgate(campanhaPedidoResgateId: number, statusAtual: number, status: number): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR, DispatchType.LOADING, 'Atualizando status...', StateType.Master))
		const asyncResponse = await _AprovarPedidoService.AprovarPedido(
			campanhaPedidoResgateId,
			statusAtual,
			_UserData.Get(UserDataBaseEnum.UsuarioAcesso),
			_UserData.Get(UserDataBaseEnum.EmpresaID),
			status
		)

		if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_APROVAR
			})
		} else {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_APROVAR
			})
			dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR, DispatchType.ERROR, "Erro ao mudar status!", StateType.Master))
		}
	}
}

export function ReprovarResgate(campanhaPedidoResgateId: number, motivo: string, usuario: string): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR, DispatchType.LOADING))

		const asyncResponse = await _AprovarPedidoService.ReprovarPedido(campanhaPedidoResgateId, motivo, usuario)

		if (ResponseValid(asyncResponse, false, dispatch)) {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_REPROVAR
			})
			dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR, DispatchType.SUCCESS, "Resgate reprovado com sucesso!", StateType.Local))
		}
	}
}
